import React from 'react';
import CategoryTagFilters from './CategoryTagFilters';
import useCompactLandscape from '../../hooks/useCompactLandscape';

// Legend footer shared by the Month/Week/List views: category pills followed
// by tag pills, doubling as filter controls (see CategoryTagFilters).
// Always a fixed, single-line height — categories never shrink or wrap; if
// the tags don't all fit, CategoryTagFilters (in fitTagsToWidth mode) simply
// shows as many whole tag pills as fit plus a "+N" hint for the rest.
// Hidden on phones — portrait (below md:) and landscape (useCompactLandscape),
// where the height is better spent on the calendar; the same category/tag
// filters are in the Filter panel.
const CalendarLegend = ({ tokens, events, selectedCategory, onCategoryClick, selectedTags, onTagClick }) => {
    const c = tokens.colors;
    const isCompactLandscape = useCompactLandscape();
    if (isCompactLandscape) return null;
    return (
        <div
            className="hidden md:flex"
            style={{
                alignItems: 'center', padding: '7px 26px',
                flex: '0 0 auto', background: c.surfaceAlt, borderTop: `1px solid ${c.gridLine}`,
            }}
        >
            <CategoryTagFilters
                tokens={tokens}
                events={events}
                selectedCategory={selectedCategory}
                onCategoryClick={onCategoryClick}
                selectedTags={selectedTags}
                onTagClick={onTagClick}
                fitTagsToWidth
            />
        </div>
    );
};

export default CalendarLegend;
